// extracted by mini-css-extract-plugin
export default {"styled-nav":"Menu_styled-nav__YBFtC","slide":"Menu_slide__FpA6n","styled-nav-hidden":"Menu_styled-nav-hidden__HHaiA","cross":"Menu_cross__8Q9Z3"};